import classNames from 'classnames';
import type { ReactElement, RefObject } from 'react';
import { useRef } from 'react';
import type { CardImageProps } from './CardImage.data';
import styles from './CardImage.module.scss';
import Image from '../../../atoms/image/Image';
import { cleanMediaQueries } from '../../../../hooks/useDeviceStateTracker';

export default function CardImage({
  className,
  fullBleed,
  imageInnerTransition,
  srcDesktop,
  src,
  altText,
  ref,
}: CardImageProps): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;

  return (
    <>
      {(src || srcDesktop) && (
        <Image
          ref={elementRef}
          src={src || (srcDesktop as string)}
          srcDesktop={srcDesktop || (src as string)}
          className={classNames(styles.image, className)}
          sizes={
            fullBleed
              ? '100vw'
              : `${cleanMediaQueries.MIN_768} 768px, ${cleanMediaQueries.MIN_1024} 1024px, ${cleanMediaQueries.MIN_1920} 1024px, 100vw`
          }
          innerTransition={imageInnerTransition}
          layout="fill"
          objectFit="cover"
          alt={altText ?? ''}
        />
      )}
    </>
  );
}
